<template>

  <div class="cf">
    <div class="cf-page cf-stack cf-stack--8 cf-aisok">

      <div class="cf-stack" style="gap:10px">
        <span class="cf-eyebrow">Weryfikacja EasyCheck zakończona</span>
        <h1 class="cf-h1">{{ timedOut ? 'Analiza danych bankowych jeszcze trwa' : 'Analizujemy dane z Twojego banku' }}</h1>
        <p v-if="!timedOut" class="cf-lead" style="margin:0">Otrzymaliśmy dane z Twojego banku. Trwa analiza historii rachunku
          — zazwyczaj zajmuje to <strong>do 1,5 minuty</strong>.</p>
      </div>


      <!-- trwa polling -->
      <section v-if="isPolling" class="cf-card cf-wait" aria-live="polite">
        <span class="cf-spinner" aria-hidden="true"></span>
        <div class="cf-stack" style="gap:8px;flex:1">
          <span class="cf-note__title">Analizujemy historię Twojego rachunku…</span>
          <span class="cf-note__hint"><strong>Prosimy o pozostanie na tej stronie</strong> — nie zamykaj okna przeglądarki
            i nie odświeżaj strony. Po zakończeniu analizy przejdziemy dalej automatycznie.</span>
          <span v-if="showReassurance" class="cf-note__hint">Analiza nadal trwa. Jeśli nie zakończy się w ciągu kilkudziesięciu sekund,
            poprosimy Cię o sprawdzenie wyniku w panelu klienta.</span>
          <span class="cf-meta cf-elapsed">Czas oczekiwania: <strong>{{ elapsedFormatted }}</strong></span>
        </div>
      </section>


      <!-- limit czasu - klient sprawdzi wynik w panelu -->
      <aside v-if="timedOut" class="cf-note cf-note--warn">
        <span class="cf-note__count">i</span>
        <div class="cf-stack" style="gap:12px;flex:1">
          <span class="cf-note__title">Otrzymaliśmy dane z Twojego banku, jednak ich analiza nie została jeszcze zakończona.</span>
          <span class="cf-note__hint">Nie musisz dłużej czekać na tej stronie. Wynik weryfikacji oraz kolejny krok wniosku
            będą widoczne <strong>w panelu klienta po zalogowaniu</strong>. Prosimy o sprawdzenie statusu za kilka minut.</span>
          <div class="cf-row">
            <button type="button" class="cf-btn cf-btn--primary" @click="goToPanel">
              <i class="fas fa-user"></i> Przejdź do panelu klienta
            </button>
          </div>
        </div>
      </aside>

    </div>
  </div>

</template>

<script>


    //import { bus } from './main';

    // sha256
    //import sha256 from 'crypto-js/sha256';


    // Polling: max 180 s (co 5 s). Po przekroczeniu nie trzymamy klienta na stronie -
    // pokazujemy informacje, ze analiza AIS trwa i wynik bedzie w panelu klienta.
    // Przejscie 0.13 'EasyCheck got' -> 0.35 'Kontroferta' (pobranie danych transakcyjnych
    // z EasyCheck + scoring) trwalo w testach 09.09.2026 od 55 do 97 s.
    const POLL_INTERVAL_MS = 5000;
    const POLL_MAX_SEC = 180;
    // bezpiecznik na wypadek zablokowanego timera elapsed (sekundy -> ms, wczesniej
    // brak przeliczenia dawal 3 proby i timeout po ~26 s)
    const POLL_MAX_TRIES = Math.ceil(POLL_MAX_SEC * 1000 / POLL_INTERVAL_MS) + 2;
    // Po tylu sekundach pokaz lagodzacy komunikat
    const REASSURANCE_AFTER_SEC = 45;

    // komunikaty rotowane na nakladce ladowania (Loader.vue) podczas analizy AIS
    const AIS_WAIT_MESSAGES = [
      'Pobieramy historię transakcji z Twojego banku…',
      'Analizujemy wpływy i wydatki na rachunku…',
      'Sprawdzamy regularność Twoich dochodów…',
      'Porównujemy dane z bankiem z informacjami z wniosku…',
      'Przygotowujemy wynik weryfikacji…',
      'To zajmie jeszcze chwilę. Dziękujemy za cierpliwość…'
    ];


    export default {

       name: 'EasyCheckOkView',

        data(){

            return {

              modal: null,

              details: '',

              waitCount: 0,

              isPolling: false,
              pollingStartTs: 0,
              elapsedSec: 0,
              elapsedTimer: null,
              pollTimer: null,
              abandoned: false,
              reassureLogged: false,
              timedOut: false

            }
       },


       computed: {

         elapsedFormatted() {
           let s = Math.max(0, this.elapsedSec | 0),
               m = Math.floor(s / 60),
               r = s % 60;
           return (m < 10 ? '0' + m : m) + ':' + (r < 10 ? '0' + r : r);
         },

         showReassurance() {
           return this.isPolling && this.elapsedSec >= REASSURANCE_AFTER_SEC;
         }
       },


       watch: {

         showReassurance(val) {
           if (val && !this.reassureLogged) {
             this.reassureLogged = true;
             this.log('easycheck polling - reassurance shown', 'elapsed=' + this.elapsedSec + 's', 'tries=' + this.waitCount);
           }
         }
       },


       methods: {


            gotomain(){

                this.$router.push({path: '/'});
            },


            goToPanel() {

              var page = this.$root.mainpage;

              this.log('easycheck timeout - go to client panel', page.loggedIn ? 'logged-in' : 'login-dialog');

              if (page.loggedIn) {
                this.$router.push({path: '/client'});
              }
              else {
                this.echo('login_dialog');
              }
            },


            startElapsedTimer() {

              this.pollingStartTs = Date.now();
              this.elapsedSec = 0;

              this.elapsedTimer = setInterval(() => {
                this.elapsedSec = Math.floor((Date.now() - this.pollingStartTs) / 1000);
              }, 1000);
            },


            stopElapsedTimer() {

              if (this.elapsedTimer) {
                clearInterval(this.elapsedTimer);
                this.elapsedTimer = null;
              }
            },


            cancelPollTimer() {

              if (this.pollTimer) {
                clearTimeout(this.pollTimer);
                this.pollTimer = null;
              }
            },


            onVisibilityChange() {

              if (!this.isPolling) return;

              if (document.visibilityState === 'hidden') {
                this.abandoned = true;
                this.log('easycheck polling - tab hidden, possible abandonment', 'elapsed=' + this.elapsedSec + 's', 'tries=' + this.waitCount);
              }
              else if (document.visibilityState === 'visible') {
                this.log('easycheck polling - tab visible again', 'elapsed=' + this.elapsedSec + 's', 'tries=' + this.waitCount);
              }
            },


            onBeforeUnload() {

              if (this.isPolling) {
                this.abandoned = true;
                this.log('easycheck polling ABANDONED - page unload', 'elapsed=' + this.elapsedSec + 's', 'tries=' + this.waitCount);
              }
            },


            onPageHide() {

              if (this.isPolling) {
                this.abandoned = true;
                this.log('easycheck polling ABANDONED - pagehide', 'elapsed=' + this.elapsedSec + 's', 'tries=' + this.waitCount);
              }
            },



            onWaiting( endpoint='application' ) {


              var page = this.$root.mainpage,
                  step,


                poll = () => {

                  if (this.elapsedSec >= POLL_MAX_SEC || this.waitCount > POLL_MAX_TRIES) {

                    this.log('easycheck polling TIMEOUT - client sent to panel', 'tries=' + this.waitCount, 'elapsed=' + this.elapsedSec + 's');

                    this.isPolling = false;
                    this.stopElapsedTimer();
                    page.isLoading = false;

                    // nie przetrzymujemy klienta - wynik AIS sprawdzi w panelu po zalogowaniu
                    this.timedOut = true;
                    this.pageTop();
                    return;
                  }

                  this.waitCount++;


                  this.get( '/' + endpoint )
                      .then(response => {


                        if (!!response.data) {

                          step = response.data.hasOwnProperty('step') ? response.data.step : '';


                          !step.match(/wait|kontomatik/)
                            && this.log( 'easycheck done - status polling done, go to ' + step, 'tries=' + this.waitCount, 'elapsed=' + this.elapsedSec + 's' );

        //console.log(step);

                          switch (step) {

                            case 'kontomatik':
                            case 'wait':
                              // log progres - okresowy heart-beat z postepu pollingu
                              if (this.waitCount % 10 === 0) {
                                this.log('easycheck polling progress', 'step=' + step, 'tries=' + this.waitCount, 'elapsed=' + this.elapsedSec + 's');
                              }
                              break;


                            case 'counteroffer':

                              this.isPolling = false;
                              this.stopElapsedTimer();
                              page.isLoading = false;


                              // flag to make sure step was completed
                              page.aisdone = true;

                              // gtag
                              /*dataLayer.push({
                                event: 'verification_success',
                                loan_amount: this.loanAmount,
                                user_email: SHA256(this.form.client_email),
                                user_phone: SHA256(this.form.client_cellphone)
                              });*/




                              this.finishDate = response.data.last_installment_date.split(' ')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1');



//console.log(this.finishDate);


                              this.setValues( parseInt(response.data.net_amount),  parseInt(response.data.installments_nbr), this.getConf('tenor_sign'), this.finishDate );




//console.log(this.finishDate);





                              this.$router.push({path: 'proposal'});
                              return;


                            case 'account':
                              this.isPolling = false;
                              this.stopElapsedTimer();
                              page.isLoading = false;

                              this.$router.push({path: 'account'});
                              return;



                            case 'reject':
                              this.isPolling = false;
                              this.stopElapsedTimer();
                              page.isLoading = false;

                              // gtag
                              /*dataLayer.push({
                                event: 'verification_failed',
                                loan_amount: this.loanAmount,
                                user_email: sha256(this.form.client_email),
                                user_phone: sha256(this.form.client_phone)
                              });*/


                              this.$router.push({path: 'rej'});
                              return;


                            case 'amodit':
                              this.isPolling = false;
                              this.stopElapsedTimer();
                              page.isLoading = false;

                              let url = response.data.step_details.split('/');

                              window.location = this.getConf('amoditSignUrl') + url[ url.length - 2 ] + '%2F' + url[ url.length - 1 ];
                              return;


                            default:
                              this.isPolling = false;
                              this.stopElapsedTimer();
                              page.isLoading = false;

                              this.$router.push({path: 'thankyou'});
                              return;
                          }


        //console.log(response.data)


                        }
                        else {
                          this.log('easycheck polling - empty body', 'tries=' + this.waitCount);
                        }


                        // dispatch another poll request
                        if (page.isLoading && this.isPolling) {
                          this.pollTimer = setTimeout(poll, POLL_INTERVAL_MS);
                        }



                      })
                      .catch(error => {

                          this.log('easycheck polling - request error', 'tries=' + this.waitCount, error && error.message ? error.message : 'no-msg');

                          // wait for timeout
                          //page.isLoading = false;
                          if (this.isPolling) {
                            this.pollTimer = setTimeout(poll, POLL_INTERVAL_MS);
                          }


                          // Error
                          if (error.response) {


                          } else if (error.request) {

                          } else {
                              // Something happened in setting up the request and triggered an Error
                              //console.log('Error', error.message);
                          }
                      });


                };


                // log
                this.isPolling = true;
                this.startElapsedTimer();
                this.log( 'easycheck done - status polling start', 'max_tries=' + POLL_MAX_TRIES, 'interval_ms=' + POLL_INTERVAL_MS );


                // initial polling
                this.pollTimer = setTimeout(poll, POLL_INTERVAL_MS);
            }



       },



       created() {



            var page = this.$root.mainpage,
                me = this,
                uri = window.location.href.split('?'),
                lid = null;




// get status - for test of counteroffer on next screen only
//page.isLoading = true;
//me.onWaiting();
//return;




            if (uri.length > 1 && /lid=[0-9]+/.test(uri[1]) ) {


              let reg = uri[1].match(/lid=([0-9]+)/);

              lid = reg[1];
            }





//console.log('t10l created');

            me.log( 'easycheck page visible', lid ? 'lid=' + lid : 'no-lid' );




            !!lid && me.post( '/transactionlink', {
                              "loan_id": lid,
                              "t10l":  'easycheck'

            })
            .then(response => {

                if (!!response.data) {

                  let ok = !(response.data.IS_ERROR | 0);

                  me.log('easycheck /transactionlink response', 'ok=' + ok);

                  // get status - nakladka z komunikatami o analizie AIS
                  page.isLoading = [...AIS_WAIT_MESSAGES];

                  me.onWaiting();

                }
              })
              .catch(error => {

                  me.log('easycheck /transactionlink error', error && error.message ? error.message : 'no-msg');

                  // Error
                  if (error.response) {

                     console.log(error.response);
                  }
              });




          // scroll to top
          this.pageTop();

       },



       mounted() {

         document.addEventListener('visibilitychange', this.onVisibilityChange, true);
         window.addEventListener('beforeunload', this.onBeforeUnload, true);
         window.addEventListener('pagehide', this.onPageHide, true);
       },



       beforeDestroy() {

         if (this.isPolling && !this.abandoned) {
           this.log('easycheck polling - view destroyed before completion', 'tries=' + this.waitCount, 'elapsed=' + this.elapsedSec + 's');
         }

         this.isPolling = false;
         this.cancelPollTimer();
         this.stopElapsedTimer();

         document.removeEventListener('visibilitychange', this.onVisibilityChange, true);
         window.removeEventListener('beforeunload', this.onBeforeUnload, true);
         window.removeEventListener('pagehide', this.onPageHide, true);
       }



    }
</script>



<style scoped>

.cf-page {
  padding: 44px 64px 56px;
  max-width: 960px;
}

.cf-elapsed strong {
  font-variant-numeric: tabular-nums;
  font-feature-settings: 'tnum';
}

@media (max-width: 900px) {

  .cf-page {
    padding: 24px 18px 40px;
  }
}

</style>



// WEBPACK FOOTER //
// src/EasyCheckOkView.vue